import { render, staticRenderFns } from "./PromoSlider.vue?vue&type=template&id=4368be42&"
import script from "./PromoSlider.vue?vue&type=script&lang=js&"
export * from "./PromoSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports